import { render, staticRenderFns } from "./BaseUpload.vue?vue&type=template&id=f133c9de&scoped=true"
import script from "./BaseUpload.vue?vue&type=script&lang=js"
export * from "./BaseUpload.vue?vue&type=script&lang=js"
import style0 from "./BaseUpload.vue?vue&type=style&index=0&id=f133c9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f133c9de",
  null
  
)

export default component.exports